import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

import { Stack, Typography } from '@mui/material'
import { skipToken } from '@reduxjs/toolkit/query'
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab'

import Tick from 'assets/icons/Circle Green Revised.png'

import { useGetOrderStatusQuery } from 'store/orders/orders.api'
import {
  convertTimestampToDateAndTime,
  formatEventType,
} from 'pages/invoice/invoice.utils'

const InvoiceDialogTimelineTracking = () => {
  const orderId = useSelector(
    (state: RootState) => state.invoices.selectedOrderId
  )

  const { data: orderstatus, refetch } = useGetOrderStatusQuery({
    orderId: Number(orderId) ?? skipToken,
  })

  useEffect(() => {
    refetch()
  }, [refetch])

  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {orderstatus?.map((event, index) => (
        <TimelineItem key={event?.type}>
          <TimelineSeparator>
            {/* <TimelineDot /> */}
            <img src={Tick} alt="check icon" width={20} height={20} />
            {index < orderstatus.length - 1 && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent sx={{ mt: -1 }}>
            <Stack>
              <Typography fontWeight={700}>
                {formatEventType(event.type)}
              </Typography>
              <Stack direction="row" spacing={1}>
                <Typography fontWeight={300}>
                  {convertTimestampToDateAndTime(event?.completed?.timestamp)?.date}
                </Typography>
                <Typography fontWeight={700}>
                  {convertTimestampToDateAndTime(event?.completed?.timestamp)?.time}
                </Typography>
              </Stack>
            </Stack>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  )
}

export default InvoiceDialogTimelineTracking
